export default "__VITE_ASSET__B$7oD$gc__"